export const dropdownBaseStateSymbol = Symbol('Dropdown Base state');
